import { Briefcase, BookUser, Layers, Landmark, Users2, Box } from "lucide-react";
import { useAuth } from "@/lib/authContext";
import { HeaderSplitNav, type HeaderSplitNavEntry } from "./HeaderSplitNav";

const ACCOUNTS_ROUTES = ["/accounts", "/my-accounts", "/client-groups", "/sources", "/contacts", "/engagements"];

export function AccountsNav() {
  const { user } = useAuth();
  const role = user?.role || "staff";

  const entries: HeaderSplitNavEntry[] = [
    { label: "Accounts", href: "/accounts", icon: Briefcase },
    { label: "My Accounts", href: "/my-accounts", icon: BookUser, roles: ["staff", "manager", "admin"] },
    { label: "Client Groups", href: "/client-groups", icon: Layers },
    { label: "Financial Sources", href: "/sources", icon: Landmark, roles: ["staff", "manager", "admin"] },
    { label: "Contacts", href: "/contacts", icon: Users2 },
    { label: "Engagements", href: "/engagements", icon: Box },
  ].filter((e) => !e.roles || e.roles.includes(role));

  return (
    <HeaderSplitNav
      label="Accounts"
      icon={Briefcase}
      href="/accounts"
      entries={entries}
      activeRoutes={ACCOUNTS_ROUTES}
      testId="accounts"
    />
  );
}
